import Data from './data'

export default {
    list: () => [200, Data.list],
    create: () => [200],
}
